export default __webpack_public_path__ + "static/media/IHN.d2d3e0d8.jfif";